import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuTitleWithLabel } from 'ui-components/components/dropdown-menu-title-with-label';
import { defineMessages, FormattedMessage } from 'react-intl';
import { emptyArray } from 'ui-components/default-props/empty';

const messages = defineMessages({
  mappings: {
    description: 'formatDropdown.mappings',
    defaultMessage: 'Mappings',
    id: 'niWsIU',
  },
});

const SavedMappingDropdown = ({ className, togglerClassName, onMappingSelected, mappings = emptyArray, mappingName = null }) => {
  const selectedMapping = mappings.filter(({ name }) => name === mappingName)[0];
  return (
    <DropdownMenu className={className}>
      <DropdownMenuToggler className={togglerClassName}>
        <DropdownMenuTitleWithLabel
          label={<FormattedMessage {...messages.mappings} />}
          title={selectedMapping ? selectedMapping.name : ''}
        />
      </DropdownMenuToggler>
      {mappings.map(({ name }) => (
        <DropdownMenuItem key={name} onClick={() => onMappingSelected(name)} selected={name === mappingName}>
          {name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

SavedMappingDropdown.propTypes = {
  className: PropTypes.string,
  onMappingSelected: PropTypes.func.isRequired,
  togglerClassName: PropTypes.string,
  mappingName: PropTypes.string,
  mappings: PropTypes.array,
};

export default SavedMappingDropdown;
